// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import config from './utils/config'
import language from './utils/language'
import change from './utils/change'
import top from './components/top'
import foot from './components/foot'
import form2 from './components/form2'
import formModal from './components/formModal'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import './assets/css/quill.bubble.css';
import './assets/css/quill.core.css';
import './assets/css/quill.snow.css';

Vue.use(ViewUI);

Vue.component('top', top)
Vue.component('foot', foot)
Vue.component('form2', form2)
Vue.component('formModal', formModal)

Vue.config.productionTip = false
Vue.$config = Vue.prototype.$config = config
Vue.$goMap = Vue.prototype.$goMap = change.goMap
Vue.$call = Vue.prototype.$call = change.call
Vue.$clickBanner = Vue.prototype.$clickBanner = change.clickBanner
Vue.$language = Vue.prototype.$language = language

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js